import { render, staticRenderFns } from "./ProductChart.vue?vue&type=template&id=cacbeb7c&"
import script from "./ProductChart.vue?vue&type=script&lang=js&"
export * from "./ProductChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports